/**
 * RENDER CATEGORIES + SEARCH/CATEGORIES UI controls.
 *
 * Phase 5 modularization (Sprint 6, 2026-05-07).
 * Извлечено из public/js/app.js.
 *
 *   - renderCategories()       — рендер кнопок-фильтров категорий в каталоге
 *                                (с popularity-based сортировкой и системной "Не определено")
 *   - toggleSearch()           — показать/скрыть search-box
 *   - toggleSearchExpand()     — раскрыть expandable search-input
 *   - toggleCategories()       — свернуть/развернуть весь блок категорий
 *
 * @module app/render-categories
 */

/**
 * Прикрепляет render-categories методы к prototype класса.
 * @param {Function} ClassRef - класс ProfessionalQuoteCalculator
 */
export function attachRenderCategories(ClassRef) {
    Object.assign(ClassRef.prototype, {
        renderCategories() {
            const container = document.getElementById('category-buttons-container');
            if (!container) return;

            // Проверяем, есть ли услуги в категории "Не определено"
            const hasUndefinedServices = this.templates.some(t => t.category === 'undefined');
            const undefinedCount = this.templates.filter(t => t.category === 'undefined').length;

            console.log(`renderCategories: hasUndefinedServices=${hasUndefinedServices}, count=${undefinedCount}`);

            // Проверяем наличие категории "undefined" в списке всех категорий
            const undefinedCategoryExists = this.categories.some(cat => cat.id === 'undefined');
            const undefinedCategory = this.categories.find(cat => cat.id === 'undefined');
            console.log(`renderCategories: undefinedCategoryExists=${undefinedCategoryExists}`, undefinedCategory);
            console.log(`renderCategories: all categories:`, this.categories.map(c => `${c.name}(${c.id})`).join(', '));

            // Фильтруем категории: показываем "Не определено" только если там есть услуги
            const visibleCategories = this.categories.filter(cat => {
                if (cat.id === 'undefined') {
                    console.log(`renderCategories: filtering "undefined" category, hasUndefinedServices=${hasUndefinedServices}`);
                    return hasUndefinedServices;
                }
                return true;
            });

            console.log(`renderCategories: visible categories=${visibleCategories.length}:`, visibleCategories.map(c => c.name).join(', '));

            container.innerHTML = visibleCategories.map(cat => `
                <button class="category-btn" data-category="${cat.id}">
                    ${this.renderIcon(cat.icon, '11px')} ${cat.name}
                </button>
            `).join('');

            // Инициализация Lucide иконок
            lucide.createIcons();

            // Re-bind category events
            container.querySelectorAll('.category-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
                    e.target.classList.add('active');
                    const categoryId = e.target.dataset.category;
                    this.state.activeCategory = categoryId;

                    // Track category selection (except "all")
                    if (categoryId !== 'all') {
                        this.trackCategoryUsage(categoryId);
                        console.log(`Category clicked: ${categoryId}, new usage: ${this.categoryStats.usage[categoryId]}`);
                    }

                    this.renderTemplates();
                });
            });
        },

        toggleSearch() {
            const searchBox = document.getElementById('search-box-expandable');
            const searchInput = document.getElementById('search');

            if (searchBox.style.display === 'none') {
                searchBox.style.display = 'block';
                setTimeout(() => searchInput.focus(), 100);
            } else {
                searchBox.style.display = 'none';
                searchInput.value = '';
                this.filterTemplates('');
            }
        },

        toggleSearchExpand() {
            const btn = document.getElementById('search-expand-btn');
            const searchInput = btn.querySelector('.search-input');

            if (btn.classList.contains('expanded')) {
                btn.classList.remove('expanded');
                searchInput.value = '';
                this.filterTemplates('');
            } else {
                btn.classList.add('expanded');
                setTimeout(() => searchInput.focus(), 100);
            }
        },

        toggleCategories() {
            const container = document.getElementById('category-buttons-container');
            const toggleBtn = document.getElementById('categories-toggle-btn');

            if (container.style.display === 'none') {
                container.style.display = 'flex';
                toggleBtn.textContent = '▼';
            } else {
                container.style.display = 'none';
                toggleBtn.textContent = '▶';
            }
        },

        // Toggle file dropdown menu
    });
}
